"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFileOutput = instanceOfFileOutput;
exports.FileOutputFromJSON = FileOutputFromJSON;
exports.FileOutputFromJSONTyped = FileOutputFromJSONTyped;
exports.FileOutputToJSON = FileOutputToJSON;
/**
 * Check if a given object implements the FileOutput interface.
 */
function instanceOfFileOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function FileOutputFromJSON(json) {
    return FileOutputFromJSONTyped(json, false);
}
function FileOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': json['data'],
    };
}
function FileOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': value['data'],
    };
}
